/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_Value_PlaceholderInputs */

const en_admin_settings_custom_value_placeholder = /** @type {(inputs: Admin_Settings_Custom_Value_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`value`)
};

const zh_admin_settings_custom_value_placeholder = /** @type {(inputs: Admin_Settings_Custom_Value_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置值`)
};

/**
* | output |
* | --- |
* | "value" |
*
* @param {Admin_Settings_Custom_Value_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_value_placeholder = /** @type {((inputs?: Admin_Settings_Custom_Value_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_Value_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_custom_value_placeholder(inputs)
	return zh_admin_settings_custom_value_placeholder(inputs)
});
export { admin_settings_custom_value_placeholder as "admin.settings.custom.value_placeholder" }